export default "__VITE_ASSET__hFbRymPU__"